import { useState } from 'react';

import { useT } from '../../i18n';
import { beendeApp } from '../../platform/beenden';
import { useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import { passtBeendenWort } from './beendenSperre';
import styles from './BeendenDialog.module.css';

/**
 * Die Tür nach draussen — sie geht nur mit der PIN auf.
 *
 * ⚠️ **`dismissible` bleibt an.** Wer ⌘Q aus Versehen gedrückt hat, muss zurückkönnen; hinter
 * dem Blatt liegt immer der Bogen. Das ist kein Loch in der Sperre: Abbrechen beendet nichts.
 *
 * ⚠️ **Kein Zählwerk, keine Sperrzeit** — dieselbe Begründung wie bei der Sperre vor den
 * Einstellungen (`sheets/einstellungenSperre.ts`): ein Prüfer, der sich mitten in einer
 * Prüfung aussperrt, ist der teurere Fehler.
 */
export function BeendenDialog() {
  const t = useT();
  const offen = useAppStore((s) => s.beendenOffen);
  const pin = useAppStore((s) => s.beendenPin);
  const setOffen = useAppStore((s) => s.setBeendenOffen);
  const [eingabe, setEingabe] = useState('');
  const [falsch, setFalsch] = useState(false);

  if (!offen) return null;

  const schliessen = () => {
    // Das Feld wird geleert: eine stehengebliebene Eingabe stünde beim nächsten ⌘Q wieder da.
    setEingabe('');
    setFalsch(false);
    setOffen(false);
  };

  const versuchen = () => {
    if (!passtBeendenWort(eingabe, pin)) {
      // Dasselbe Leeren wie bei der Einstellungssperre: ein stehengebliebenes falsches Wort
      // lädt dazu ein, denselben Versuch noch einmal abzuschicken.
      setEingabe('');
      setFalsch(true);
      return;
    }
    void beendeApp();
  };

  return (
    <Dialog kicker={t.exit.kicker} title={t.exit.title} onClose={schliessen} width={420}>
      <div className={`sc ${styles.body}`}>
        <div className={styles.note}>{t.exit.hint}</div>
        <label className={styles.row}>
          <span className={styles.label}>{t.exit.pin}</span>
          <input
            className={styles.input}
            type="password"
            value={eingabe}
            autoFocus
            autoCapitalize="off"
            autoCorrect="off"
            onChange={(e) => {
              setEingabe(e.target.value);
              setFalsch(false);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') versuchen();
            }}
          />
        </label>
        {falsch && <div className={styles.falsch}>{t.exit.wrong}</div>}
        <div className={styles.aktionen}>
          <button type="button" className={`tap ${styles.knopf}`} onClick={schliessen}>
            {t.exit.cancel}
          </button>
          <button
            type="button"
            className={`tap ${styles.knopf}`}
            data-schwer="true"
            onClick={versuchen}
          >
            {t.exit.quit}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
